import React, { useState, useEffect, useRef } from 'react'
import { Button, Collapse, Nav } from 'react-bootstrap'
import { useLazyQuery } from '@apollo/client'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'

import styles from '@shared/components/fixtureContent/style.module.scss'
import navStyles from '@shared/components/commonNav/style.module.scss'
import { SERIES_ARCHIVE } from '@graphql/fixtures/fixtures.query'
import { debounce, getTimeZone, isBottomReached } from '@shared-submodule/utils'
import SearchFilter from '../fixtureContent/searchFilter'
import { FilterIcon } from '../ctIcons'
import { archiveSeriesLoader } from '@shared/libs/allLoader'

// const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })
const DateSlider = dynamic(() => import('@shared/components/dateSlider'))
const ArchiveList = dynamic(() => import('@shared/components/series/archiveList'), {
  loading: () => archiveSeriesLoader(3)
})

const ArchiveContent = ({ data, year }) => {
  const [open, setOpen] = useState(false)
  const loading = useRef(false)
  const isReachedBottom = useRef(false)
  // const [toggleFilter, setToggleFilter] = useState(false)
  const requestParams = useRef({
    eCategory: 'i',
    dYear: new Date().getFullYear().toString(),
    sSearch: '',
    sTimezone: getTimeZone(),
    nLimit: 20,
    nSkip: 1
  })
  const [sLabel, setSLable] = useState('i')
  const MATCH_TYPE = [
    {
      sValue: 'i',
      sLabel: 'International'
    },
    {
      sValue: 'l',
      sLabel: 'League'
    },
    {
      sValue: 'd',
      sLabel: 'Domestic'
    },
    {
      sValue: 'w',
      sLabel: 'Women'
    }
  ]
  const [archiveData, setArchiveData] = useState(data?.listSeriesArchive)
  const [getArchive, { data: newArchiveData, loading: isLoading }] = useLazyQuery(SERIES_ARCHIVE)

  const latestSeries = useRef(newArchiveData?.listSeriesArchive?.length || data?.listSeriesArchive?.length)

  // const handleFilter = () => {
  //   setToggleFilter(!toggleFilter)
  // }

  const handleCategoryFilter = value => {
    setSLable(value)
    requestParams.current = { ...requestParams.current, eCategory: value, nSkip: 1 }
    getArchive({ variables: { input: requestParams.current } })
  }

  const handleYear = y => {
    requestParams.current = { ...requestParams.current, dYear: y, nSkip: 1 }
    getArchive({ variables: { input: requestParams.current } })
  }

  const handleSearch = debounce(search => {
    requestParams.current = { ...requestParams.current, sSearch: search, nSkip: 1 }
    getArchive({ variables: { input: requestParams.current } })
  })

  useEffect(() => {
    loading.current = false
    isBottomReached(archiveData?.[archiveData?.length - 1]?._id, isReached)
  }, [archiveData])

  function isReached(reach) {
    if (reach && !loading.current && latestSeries.current === requestParams.current.nLimit) {
      loading.current = true
      isReachedBottom.current = true
      requestParams.current = { ...requestParams.current, nSkip: requestParams.current.nSkip + 1 }
      getArchive({ variables: { input: requestParams.current } })
    }
  }

  useEffect(() => {
    if (isReachedBottom.current && newArchiveData) {
      setArchiveData([...archiveData, ...newArchiveData?.listSeriesArchive])
      loading.current = false
      isReachedBottom.current = false
    } else if (!loading.current && newArchiveData) {
      setArchiveData(newArchiveData?.listSeriesArchive)
    }
    latestSeries.current =
      newArchiveData?.listSeriesArchive?.length >= 0 ? newArchiveData?.listSeriesArchive?.length : false || data?.listSeriesArchive?.length
  }, [newArchiveData])

  return (
    <div className="position-relative">
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        variant="link"
        // className={`${styles.filterBtn} ct-border rounded-circle d-none d-md-inline-block`}
        className={`${styles.filterBtn} ct-border rounded-circle d-none`}>
        <FilterIcon />
      </Button>
      <Collapse in={open}>
        <div className={`${styles.fixturesFilter}`}>
          <div className={`${styles.bottomFilter} d-none d-md-flex flex-column flex-md-row justify-content-between mb-3`}>
            <SearchFilter handleSearch={handleSearch} />
          </div>
        </div>
      </Collapse>
      {/* <div className={`${mobilefilter.mobFixtureFilter} ${toggleFilter && mobilefilter.active}`}>
        <div className={`${mobilefilter.head} d-flex d-md-none justify-content-between align-items-center`}>
          <p className="font-semi mb-0">
            Filter
          </p>
          <Button variant="link" onClick={handleFilter} className="btn-close"></Button>
        </div>
        <div className={`${mobilefilter.innerBlock} d-block d-md-none`}>
          <SearchFilter formStyles={formStyles} mobilefilter={mobilefilter} handleSearch={handleSearch} />
        </div>
      </div> */}
      {/* <Button
        variant="link"
        onClick={handleFilter}
        className={`${mobilefilter.filterToggle} rounded-circle border-0 d-block d-md-none`}
      ></Button> */}
      {/* <div className='d-flex w-100 mb-3'>
        <CustomSelect
          options={MATCH_TYPE}
          labelKey="sLabel"
          valueKey="sValue"
          defaultValue={MATCH_TYPE[0]}
          isMedium={true}
          onChange={(e) => {
            handleCategoryFilter(e?.sValue)
          }}
        />
      </div> */}

      <Nav className={`${navStyles.commonNav} ${navStyles.pillsNav} text-uppercase flex-nowrap overflow-scroll`} variant="pills">
        {MATCH_TYPE.map(type => {
          return (
            <Nav.Item className={navStyles.item} key={type?.sValue}>
              <a
                className={` ${sLabel === type?.sValue && navStyles.active} text-capitalize nav-link`}
                onClick={() => {
                  handleCategoryFilter(type?.sValue)
                }}>
                {type?.sLabel}
              </a>
            </Nav.Item>
          )
        })}
      </Nav>
      <DateSlider year={year} handleYear={handleYear} selectedYear={requestParams.current.dYear} />
      {archiveData && <ArchiveList data={archiveData} isLoading={isLoading} />}
      {archiveData?.length === 0 && <NoData title="Quiet now, but the action is just around the corner. Keep your gear ready!" />}
    </div>
  )
}

ArchiveContent.propTypes = {
  data: PropTypes.object,
  year: PropTypes.object
}

export default ArchiveContent
